import React, { useRef } from "react";

import { CTableRow, CTableDataCell } from "@coreui/react";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

import Dropdown from "../dropdown/Dropdown";
import DropdownLink from "../dropdown/DropdownLink";
import { useMutation } from "@tanstack/react-query";
import { useHttp } from "../../hooks/useHttp";
import openToast from "../../utils/sweetAlert";

const ProspectRow = props => {
  const { customer, openCustomerModal, setCustomerId, transferConversationProspect } = props;
  const obsRef = useRef(null);
  const callRef = useRef(null);
  const [observation, updateObservation] = React.useState(customer.observation);
  const [posCall, updatePosCall] = React.useState(customer.pos_call);

  moment.locale();

  const request = useHttp();

  const { mutate: mutateObservation } = useMutation({
    mutationFn: () => request({ url: `/admin_prospect/${customer.id}`, method: "POST", data: { method: "observation", body: observation } }),
    onSuccess: res => {
      if (!res.data.error) {
        openToast("success", "Sucesso", res.data.message);
      }

      if (res.data.error) {
        openToast("error", "Ocorreu um erro", res.data.message);
      }
    }
  });

  const { mutate: mutatePosCall } = useMutation({
    mutationFn: () => request({ url: `/admin_prospect/${customer.id}`, method: "POST", data: { method: "pos_call", body: posCall } }),
    onSuccess: res => {
      if (!res.data.error) {
        openToast("success", "Sucesso", res.data.message);
      }

      if (res.data.error) {
        openToast("error", "Ocorreu um erro", res.data.message);
      }
    }
  });

  const handleUpdateObservation = () => {
    mutateObservation();
  }

  const handleUpdatePosCall = () => {
    mutatePosCall();
  }

  React.useEffect(() => {
    obsRef.current.style.height = (obsRef.current.scrollHeight + 2) + "px";
    callRef.current.style.height = (callRef.current.scrollHeight + 2) + "px";
  }, [observation, posCall]);

  return (
    <CTableRow>
      <CTableDataCell align="middle">
        <span className="text-color">{moment(customer.createdAt).format("l")}</span>
      </CTableDataCell>
      <CTableDataCell align="middle">
        <span className="text-color">{customer.name_user}</span>
      </CTableDataCell>
      <CTableDataCell align="middle">
        <textarea className="prospect__row-textarea" rows={1} ref={obsRef} type="text"
          onBlur={handleUpdateObservation} onChange={e => updateObservation(e.target.value)} value={observation} />
      </CTableDataCell>
      <CTableDataCell align="middle">
        <span className="text-color">{customer.name_prospect}</span>
      </CTableDataCell>
      <CTableDataCell align="middle">
        <span className="text-color">{customer.name_received}</span>
      </CTableDataCell>
      <CTableDataCell align="middle">
        <textarea className="prospect__row-textarea" rows={1} ref={callRef} type="text"
          onBlur={handleUpdatePosCall} onChange={e => updatePosCall(e.target.value)} value={posCall} />
      </CTableDataCell>
      <CTableDataCell align="middle" width={44}>
        <Dropdown bttnSize={34}>
          <DropdownLink to="/" onClick={e => { openCustomerModal(e, customer.user_id); setCustomerId(customer.user_id) }}>Ligar</DropdownLink>
          <DropdownLink to="/" onClick={e => transferConversationProspect(e, customer)}>Transferir novamente</DropdownLink>
        </Dropdown>
      </CTableDataCell>
    </CTableRow>
  );
}

export default ProspectRow;